import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { logoutUser } from "../api/tokenUtils";
import "../Register.css";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); 

    // Basic validation for phone number
    if (!phoneNumber || phoneNumber.length !== 10) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }
    try {
        const response = await axiosClient.post("/user/regenerate_otp/", {
            phone_number: phoneNumber,
        });
        console.log("Login response received:", response.data);
        // Navigate to VerifyOtp page and pass the phone number as state
        navigate("/verify", { state: { phoneNumber } });
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            await logoutUser();
            navigate("/login", {replace: true});
            return;
          }
            setError(error.response.data.message || "An error occurred.");
        } else {
            setError("Network error. Please check your connection and try again.");
        }
      }
  };

  const handleSignUpRedirect = () => {
    navigate("/"); // Redirect to the registration page
  };

  return (
    <div className="page-container">
      <img src="/new_logo.png" alt="Logo" className="logo" />
      <h1 className="title">Login</h1>
      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          name="phone_number"
          placeholder="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          className="input_login"
          required
        />
        <br></br>
        <button type="submit" className="submit-button">
          Continue
        </button>
      </form>
      <br></br>
      <div className="regular"> Don't have an account? 
        <button onClick={handleSignUpRedirect} className="small-button">
          Sign Up
        </button>
      </div>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default Login;
